/**
 * @generated SignedSource<<010caa63175f7f0cb0f1580b65276c6e>>
 * @relayHash 0e1d28975f68aa6ec2ee552641a14f68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 18cbe7960ed6ae8a1656cd58004426f1829eb938c56cd63c23a73e041379cc8d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiFormsQuery } from './uiFormsQuery.graphql';

const node: PreloadableConcreteRequest<uiFormsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "18cbe7960ed6ae8a1656cd58004426f1829eb938c56cd63c23a73e041379cc8d",
    "metadata": {},
    "name": "uiFormsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
